<template>
  <div class="d-flex align-center ga-1">
    <v-chip color="grey-darken-1" variant="outlined" size="x-small" class="bg-white">
      {{ $t('condition.' + condition) }}
    </v-chip>
    <sf-info-tooltip v-if="conditionDescription">
      {{ conditionDescription }}
    </sf-info-tooltip>
  </div>
</template>

<script setup lang="ts">
import SfInfoTooltip from '@/components/tooltip/SfInfoTooltip.vue'
import { Condition } from '@/generatedTypes'
import { PropType } from 'vue'

defineProps({
  condition: {
    type: String as PropType<Condition>,
    required: true
  },
  conditionDescription: {
    type: String,
    default: undefined
  }
})
</script>
